import React from "react";
import BusDetailsCard from "./BusDetailsCard";

export default function Bus10() {
  return (
    <BusDetailsCard
      busId="bus10"
      title="Bus 10 - Route Details"
      busName="Bus 10"
      vehicleNo="TN74J0234"
      backTo="/?buses=1"
    />
  );
}